// src/components/pages/message/timecapsule/PhotoCaptureModal.js

import React, { useRef, useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import ReactWebcam from "react-webcam";

const PhotoCaptureModal = ({ open, onClose, onCapture }) => {
  const webcamRef = useRef(null);
  const [facingMode, setFacingMode] = useState("environment");

  const handleCapture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      onCapture(imageSrc);
    }
  };

  const toggleFacingMode = () => {
    setFacingMode((prev) => (prev === "environment" ? "user" : "environment"));
  };

  // Show switch button only on mobile.
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "white",
          p: 2,
          width: "90%",
          maxWidth: 500,
          borderRadius: 1,
        }}
      >
        <ReactWebcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={{ facingMode }}
          style={{ width: "100%" }}
        />
        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          {isMobile && (
            <Button
              variant="outlined"
              onClick={toggleFacingMode}
              sx={(theme) => ({
                backgroundColor: theme.colors.white,
                color: theme.colors.blue,
                borderRadius: "50px",
                border: `1px solid ${theme.colors.blue}`,
                padding: "10px 20px",
                marginBottom: "4px",
                fontSize: "1rem",
                textTransform: "none",
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none",
                },
              })}
            >
              Switch Camera
            </Button>
          )}
          <Button
            variant="contained"
            onClick={handleCapture}
            sx={(theme) => ({
              backgroundColor: theme.colors.white,
              color: theme.colors.blue,
              borderRadius: "50px",
              border: `1px solid ${theme.colors.blue}`,
              padding: "10px 20px",
              marginBottom: "4px",
              fontSize: "1rem",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            })}
          >
            Capture Photo
          </Button>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={(theme) => ({
              backgroundColor: theme.colors.white,
              color: "black",
              textDecoration: "underline",
              border: "0px",
              borderRadius: "50px",
              padding: "10px 20px",
              marginBottom: "10px",
              fontWeight: "bold",
              fontSize: "1rem",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            })}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PhotoCaptureModal;
